import React, { useState } from 'react';

import type { MediaFactComponent } from '../../../../../core/data-sources/content-components/types.js';

import Text from '../articleComponents/Text/Text.js';
import { usePulseContext } from '../../../../../core/mandatory-integrations/pulse/PulseProvider.js';

const FactBox: React.FC<MediaFactComponent> = ({ paragraphs }) => {
  const [open, setOpen] = useState(false);
  const { trackClickUIElement } = usePulseContext();

  const handleOnClick = () => {
    trackClickUIElement({
      object: {
        id: `article:factbox-button-${open ? 'close' : 'open'}`,
        name: 'Factbox button',
        elementType: 'Button',
      },
    }).finally(() => setOpen(!open));
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleOnClick();
    }
  };

  return (
    <section
      className="media-fact-box"
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
    >
      <div className="fact-header">
        <div className="title-wrapper">
          <p className="fact-title-intro">FAKTA</p>
          <div className={`dropdown-button ${open ? 'open' : 'closed'}`} />
        </div>
      </div>
      {open && (
        <div className={'fact-content'}>
          <Text paragraphs={paragraphs} type="text" isFact />
        </div>
      )}
    </section>
  );
};

export default FactBox;
